import React from "react";
import "./sema.scss";
import SemaSectionBox from "./sema-section-box";
import SemaVeBisikletSurmek from "./sema-ve-bisiklet-surmek";
import SufininNotDefteri from "./sufinin-not-defteri";
import SemaSonHali from "./sema-son-hali";
import { SemaSonHaliDescription, SemaVeBisikletDescription, SufininNotDefteriDescription } from "./sema-summary-description/sema-summary-description";
import SemaCalismasi from "./sema-calismasi";
import Bisiklet from '../../assets/icons/bisiklet-transparent-241.jpg';
import Semazen from '../../assets/icons/semazen-renkli-241.jpg';
import SemaninSonHali from '../../assets/photos/sema/semanin-son-hali-almasi.jpg';
import SemaExercise from '../../assets/photos/sema-calismasi/sema-exercise.jpg';
import SemaKiyafetTekbirlenmesi from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-kiyafetlerinin-tekbirlenmesi-main.jpg';
import AvustralyaSema from '../../assets/photos/avustralya-zaviye/avustralya-sema-main.jpg';
import AvustralyaZaviye from "./avustralya-zaviye";
import SemaTekbirlenmeMerasimi from "./sema-tekbirlenme-merasimi";


interface SemaProps {

}
interface SemaState {
    SectionBoxesVisibility: SectionBoxesVisibilityType;
    IsVisibleMainSemaSection: boolean;
}

interface SectionBoxesVisibilityType {
    IsFirstBoxVisible: boolean;
    IsSecondBoxVisible: boolean;
    IsThirdBoxVisible: boolean;
    IsFourthBoxVisible: boolean;
    IsFifthBoxVisible: boolean;
    IsSixthBoxVisible: boolean;
}


class Sema extends React.Component<SemaProps, SemaState> {
    constructor(props: any) {
        super(props);
        this.state = {
            IsVisibleMainSemaSection: true,
            SectionBoxesVisibility: {
                IsFirstBoxVisible: false,
                IsSecondBoxVisible: false,
                IsThirdBoxVisible: false,
                IsFourthBoxVisible: false,
                IsFifthBoxVisible: false,
                IsSixthBoxVisible: false
            }
        };
    }

    onClickSectionBox = (boxNumber: number) => {
        this.setState({
            IsVisibleMainSemaSection: false,
            SectionBoxesVisibility: {
                IsFirstBoxVisible: boxNumber === 1,
                IsSecondBoxVisible: boxNumber === 2,
                IsThirdBoxVisible: boxNumber === 3,
                IsFourthBoxVisible: boxNumber === 4,
                IsFifthBoxVisible: boxNumber === 5,
                IsSixthBoxVisible: boxNumber === 6
            }
        });
    }

    comeBackSemaSection = () => {
        this.setState({
            IsVisibleMainSemaSection: true,
            SectionBoxesVisibility: {
                IsFirstBoxVisible: false,
                IsSecondBoxVisible: false,
                IsThirdBoxVisible: false,
                IsFourthBoxVisible: false,
                IsFifthBoxVisible: false,
                IsSixthBoxVisible: false
            }
        })
    }

    render() {
        const { IsFirstBoxVisible, IsSecondBoxVisible, IsThirdBoxVisible, IsFourthBoxVisible, IsFifthBoxVisible, IsSixthBoxVisible } = this.state.SectionBoxesVisibility;

        return (
            <section className="sema-section">
                <SemaVeBisikletSurmek isVisible={IsFirstBoxVisible} comeBackSemaSection={this.comeBackSemaSection} />
                <SufininNotDefteri isVisible={IsSecondBoxVisible} comeBackSemaSection={this.comeBackSemaSection} />
                <SemaSonHali isVisible={IsThirdBoxVisible} comeBackSemaSection={this.comeBackSemaSection} />
                <SemaCalismasi isVisible={IsFourthBoxVisible} comeBackSemaSection={this.comeBackSemaSection} />
                <AvustralyaZaviye isVisible={IsFifthBoxVisible} comeBackSemaSection={this.comeBackSemaSection} />
                <SemaTekbirlenmeMerasimi isVisible={IsSixthBoxVisible} comeBackSemaSection={this.comeBackSemaSection} />

                <div style={{ display: this.state.IsVisibleMainSemaSection ? "block" : "none" }}>
                    <div className="sema-section__content">
                        <SemaSectionBox
                            boxTitle="Bir Sufinin Not Defteri"
                            imageSource={Semazen}
                            buttonTitle="Devamını Oku"
                            boxNumber={2}
                            onClickSectionBox={this.onClickSectionBox}
                            summaryDescription={<SufininNotDefteriDescription />}
                        />

                        <SemaSectionBox
                            boxTitle="Sema Çalışması"
                            imageSource={SemaExercise}
                            buttonTitle="Devamını Oku"
                            boxNumber={4}
                            onClickSectionBox={this.onClickSectionBox}
                            summaryDescription={<SemaVeBisikletDescription />}
                        />

                        <SemaSectionBox
                            boxTitle="Sema Kıyafetlerinin Tekbirlenme Merasimi"
                            imageSource={SemaKiyafetTekbirlenmesi}
                            buttonTitle="Devamını Oku"
                            boxNumber={6}
                            onClickSectionBox={this.onClickSectionBox}
                            summaryDescription={<div></div>}
                        />

                        <SemaSectionBox
                            boxTitle="Avustralya  Melbourne Şehrindeki Zaviye"
                            imageSource={AvustralyaSema}
                            buttonTitle="Devamını Oku"
                            boxNumber={5}
                            onClickSectionBox={this.onClickSectionBox}
                            summaryDescription={<div></div>}
                        />

                        <SemaSectionBox
                            boxTitle="Sema'nın ve Bisiklet Sürmenin Ortak Tarafları"
                            imageSource={Bisiklet}
                            buttonTitle="Devamını Oku"
                            boxNumber={1}
                            onClickSectionBox={this.onClickSectionBox}
                            summaryDescription={<SemaVeBisikletDescription />}
                        />

                        <SemaSectionBox
                            boxTitle="Konya'da Sema'nın Son Halini Alması"
                            imageSource={SemaninSonHali}
                            buttonTitle="Devamını Oku"
                            boxNumber={3}
                            onClickSectionBox={this.onClickSectionBox}
                            summaryDescription={<SemaSonHaliDescription />}
                        />
                    </div>
                </div>
            </section>
        );
    }
}

export default Sema;